import { useAppSelector } from 'store/hooks';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { IResourcePermissionsList } from '@pepperhq/auth-client';
interface RestrictedRouteProps {
    resources?: IResourcePermissionsList;
    children: React.ReactNode;
}

export const RestrictedRoute: React.FC<RestrictedRouteProps> = ({ resources, children }) => {
    const claims = useAppSelector(state => state.auth.claims);
    if (!resources || claims.hasPermissions(resources)) {
        return children;
    }
    return <Navigate to="/" replace />;
};
